import { render, staticRenderFns } from "./CrmIndex.vue?vue&type=template&id=0fc6d3ba"
import script from "./CrmIndex.vue?vue&type=script&lang=js"
export * from "./CrmIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports